import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Remet systématiquement la page tout en haut lors d'un changement de route.
 * Aucun smooth scroll : le saut est instantané pour ne jamais conserver
 * la position de scroll précédente (notamment vers /vehicules).
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Appel direct : saut instantané, aucune animation smooth, pas de position conservée.
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;